// extracted by mini-css-extract-plugin
export var modal = "_th-0";
export var table = "_th-1";